import { ExclamationCircleFilled } from '@ant-design/icons';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { formatarData } from '../../../../../../../helpers/data';
import {
  formatarMoeda,
  formatarTonelada,
} from '../../../../../../../helpers/formatador';
import StatusLoteEnum from '../../../../../Enum/StatusLoteEnum';
import TipoDirecionamentoEnum from '../../../../../Enum/TipoDirecionamentoEnum';
import { Container, InfoHeader } from './styles';

const AgendamentoInfo = ({
  dataAgendada,
  freteEmpresaShipperAgendada,
  cadenciaAgendada,
  volumeAgendado,
  freteMotoristaPfAgendado,
  freteMotoristaPjAgendado,
  freteEmpresaPfAgendado,
  freteEmpresaPjAgendado,
  tipoDirecionamento,
  statusAgendado,
}) => (
  <Container>
    <InfoHeader>
      <h4>
        <ExclamationCircleFilled size={14} />
        <b>
          {`Valores com alteração agendada para ${formatarData(dataAgendada)}`}
        </b>
      </h4>
    </InfoHeader>

    {statusAgendado && (
      <Row style={{ marginBottom: 16 }}>
        <Col span={11}>
          <p>
            <b>Status</b>
          </p>
          <p>{StatusLoteEnum.getTipo(statusAgendado).label}</p>
        </Col>
      </Row>
    )}

    {tipoDirecionamento === TipoDirecionamentoEnum.TRANSPORTADORA &&
      freteEmpresaShipperAgendada && (
        <Row style={{ marginBottom: 16 }}>
          <Col span={11}>
            <p>
              <b>Frete empresa</b>
            </p>
            <p>{formatarMoeda(freteEmpresaShipperAgendada)}</p>
          </Col>
        </Row>
      )}

    {tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE && (
      <>
        {freteMotoristaPjAgendado &&
          freteMotoristaPfAgendado &&
          freteMotoristaPjAgendado !== freteMotoristaPfAgendado && (
            <Row style={{ marginBottom: 16 }}>
              <Col span={11}>
                <p>
                  <b>Frete motorista (PJ/PF)</b>
                </p>
                <p>
                  {formatarMoeda(freteMotoristaPjAgendado)} /{' '}
                  {formatarMoeda(freteMotoristaPfAgendado)}
                </p>
              </Col>
              <Col span={11} offset={2}>
                <p>
                  <b>Frete empresa (PJ/PF)</b>
                </p>
                <p>
                  {formatarMoeda(freteEmpresaPjAgendado)} /{' '}
                  {formatarMoeda(freteEmpresaPfAgendado)}
                </p>
              </Col>
            </Row>
          )}

        {freteMotoristaPjAgendado &&
          freteMotoristaPfAgendado &&
          freteMotoristaPjAgendado === freteMotoristaPfAgendado && (
            <Row style={{ marginBottom: 16 }}>
              <Col span={11}>
                <p>
                  <b>Frete motorista (PJ/PF)</b>
                </p>
                <p>{formatarMoeda(freteMotoristaPjAgendado)}</p>
              </Col>
              <Col span={11} offset={2}>
                <p>
                  <b>Frete empresa (PJ/PF)</b>
                </p>
                <p>{formatarMoeda(freteEmpresaPjAgendado)}</p>
              </Col>
            </Row>
          )}

        {freteMotoristaPjAgendado && !freteMotoristaPfAgendado && (
          <Row style={{ marginBottom: 16 }}>
            <Col span={11}>
              <p>
                <b>Frete motorista (PJ)</b>
              </p>
              <p>{formatarMoeda(freteMotoristaPjAgendado)}</p>
            </Col>
            <Col span={11} offset={2}>
              <p>
                <b>Frete empresa (PJ)</b>
              </p>
              <p>{formatarMoeda(freteEmpresaPjAgendado)}</p>
            </Col>
          </Row>
        )}

        {freteMotoristaPfAgendado && !freteMotoristaPjAgendado && (
          <Row style={{ marginBottom: 16 }}>
            <Col span={11}>
              <p>
                <b>Frete motorista (PF)</b>
              </p>
              <p>{formatarMoeda(freteMotoristaPfAgendado)}</p>
            </Col>
            <Col span={11} offset={2}>
              <p>
                <b>Frete empresa (PF)</b>
              </p>
              <p>{formatarMoeda(freteEmpresaPfAgendado)}</p>
            </Col>
          </Row>
        )}
      </>
    )}

    <Row>
      {cadenciaAgendada && (
        <Col span={11}>
          <p>
            <b>Cadência</b>
          </p>
          <p>{formatarTonelada(cadenciaAgendada)}</p>
        </Col>
      )}
      {volumeAgendado && (
        <Col span={11} offset={cadenciaAgendada ? 2 : ''}>
          <p>
            <b>Volume</b>
          </p>
          <p>{formatarTonelada(volumeAgendado)}</p>
        </Col>
      )}
    </Row>
  </Container>
);

AgendamentoInfo.propTypes = {
  dataAgendada: PropTypes.string.isRequired,
  freteEmpresaShipperAgendada: PropTypes.number.isRequired,
  cadenciaAgendada: PropTypes.number,
  volumeAgendado: PropTypes.number,
  freteMotoristaPfAgendado: PropTypes.number,
  freteMotoristaPjAgendado: PropTypes.number,
  tipoDirecionamento: PropTypes.number.isRequired,
  statusAgendado: PropTypes.number,
  freteEmpresaPfAgendado: PropTypes.number,
  freteEmpresaPjAgendado: PropTypes.number,
};

AgendamentoInfo.defaultProps = {
  freteEmpresaPjAgendado: null,
  freteEmpresaPfAgendado: null,
  statusAgendado: null,
  freteMotoristaPjAgendado: null,
  freteMotoristaPfAgendado: null,
  cadenciaAgendada: null,
  volumeAgendado: null,
};

export default AgendamentoInfo;
